import AssessmentQuestion from '../models/AssessmentQuestion';
import Data from './Data';

class AssessmentQuestions extends Data {
    constructor() {
        super(AssessmentQuestion);
    }

    async getForSector(sector) {
        return (await this.all()).filter(q => q.sector === sector);
    }
}

export default new AssessmentQuestions();
